import { SnapshotGridCore } from "@/modules/snapshots/grid/SnapshotGridCore";
import { PIPELINE_PREVIEW_CAPABILITIES } from "@/modules/snapshots/grid/dataSource";
import { useGetActiveDirectoryUsersQuery } from "@/api/users-admin";
import * as React from "react";

interface Props {
  runId: string;
  readOnly?: boolean;
}

export const SummaryReviewStage = ({ runId, readOnly = false }: Props) => {
  const owners = useGetActiveDirectoryUsersQuery();
  const ownerNamesById = React.useMemo(
    () => new Map((owners.data ?? []).map(owner => [owner.id, `${owner.name} ${owner.surname}`.trim()])),
    [owners.data],
  );

  return (
    <SnapshotGridCore
      key={runId}
      mode="pipeline-preview"
      pipelineRunId={runId}
      capabilities={PIPELINE_PREVIEW_CAPABILITIES}
      pipelineReadOnly={readOnly}
      pipelineOwnerNamesById={ownerNamesById}
    />
  );
};
